import React from 'react';
import { Row, Col, Button, Dropdown } from 'react-bootstrap';
import { Search, Funnel, ArrowDown, ArrowUp } from 'react-bootstrap-icons';
import { FormControl } from 'react-bootstrap';

const SearchArea = ({
  hideQuery = false,
  query,
  onQueryChange,
  onSearchClick,
  disabled,
  maxLimit,
  maxLimitOptions,
  onMaxLimitOptionChange,
  sortBy,
  sortByOptions,
  onSortByOptionChange,
  descSort,
  onDescSortButtonClick,
  onFilterButtonClick
}) => {
  const handleReturn = e => {
    if (!disabled && e.key === 'Enter') {
      onSearchClick && onSearchClick();
    }
  };

  // Native selects stay usable inside the independently scrolling filter panel.
  if (hideQuery) return <Row className="mt-1">
    <Col xs={6} md={4}><label className="small mb-1" htmlFor="workspace-limit">Showing</label>
      <FormControl as="select" size="sm" id="workspace-limit" disabled={disabled} value={maxLimit} onChange={e => onMaxLimitOptionChange(e.target.value === 'All' ? 'All' : Number(e.target.value))}>
        {maxLimitOptions.map(option => <option key={option} value={option}>{option}</option>)}
      </FormControl>
    </Col>
    <Col xs={6} md={4}><label className="small mb-1" htmlFor="workspace-sort">Sort by</label>
      <FormControl as="select" size="sm" id="workspace-sort" disabled={disabled} value={sortBy} onChange={e => onSortByOptionChange(e.target.value)}>
        {sortByOptions.map(option => <option key={option.key} value={option.key}>{option.name}</option>)}
      </FormControl>
    </Col>
    <Col xs={12} md={4} className="d-flex align-items-end mt-2">
      <Button size="sm" variant="outline-primary" disabled={disabled} onClick={onDescSortButtonClick}>{descSort ? 'Descending' : 'Ascending'}</Button>
      {onFilterButtonClick && <Button size="sm" className="ml-2" onClick={onFilterButtonClick} disabled={disabled}>More filters</Button>}
    </Col>
  </Row>;

  return (
    <Row className="px-md-3 mt-1">
      {!hideQuery && <Col xs={12} md={12} lg={7}>
        <div className="input-group mb-1">
          <FormControl
            id="searchText"
            placeholder="Name, phone, email or other details…"
            onKeyPress={handleReturn}
            value={query}
            onChange={e => onQueryChange(e.target.value)}
            size="sm"
          />
          <div className="input-group-append">
            <Button size="sm" variant="primary" disabled={disabled} onClick={onSearchClick}>
              <Search className="align-text-top mr-2" size={16} />
              Search
            </Button>
          </div>
        </div>
      </Col>}
      <Col xs={12} md={{ span: 4, offset: 2 }} lg={{ span: 2, offset: 0 }} className="pl-md-0">
        <Dropdown className="mb-1 mb-md-0">
          <Dropdown.Toggle size="sm" disabled={disabled} block variant="outline-primary" id="dropdown-basic">
            Showing
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {maxLimitOptions.map(option => (
              <Dropdown.Item active={option === maxLimit} key={option} onClick={() => onMaxLimitOptionChange(option)}>
                {option}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
      <Col
        xs={onFilterButtonClick ? 8 : 10}
        md={onFilterButtonClick ? 4 : 5}
        lg={{ span: onFilterButtonClick ? 1 : 2, offset: 0 }}
        className={`pr-0 pr-md-0  pl-md-0`}
      >
        <Dropdown className="mb-1 mb-md-0">
          <Dropdown.Toggle size="sm" disabled={disabled} block variant="outline-primary" id="dropdown-basic">
            Sort By
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {sortByOptions.map(option => (
              <Dropdown.Item
                active={option.key === sortBy}
                key={option.key}
                onClick={() => onSortByOptionChange(option.key)}
              >
                {option.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
      <Col xs={2} md={1} lg={{ span: 1, offset: 0 }} className="pl-1">
        <Button variant="primary" block size="sm" disabled={disabled} onClick={onDescSortButtonClick}>
          {descSort ? <ArrowDown className="text-align-top" /> : <ArrowUp className="text-align-top" />}
        </Button>
      </Col>

      {onFilterButtonClick && (
        <Col xs={2} md={1} lg={1}>
          <Button size="sm" variant="primary" block onClick={onFilterButtonClick} disabled={disabled}>
            <Funnel className="align-text-top" />
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default SearchArea;
